module.exports = __webpack_public_path__ + "img/icon_setting_white.32b91253.svg";